import { Injectable } from '@angular/core';

export interface RuntimeConfig {
  apiBaseUrl: string;
}

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private config: RuntimeConfig | null = null;

  async load(): Promise<void> {
    try {
      const res = await fetch('/assets/runtime-config.json', {
        cache: 'no-store'
      });
      if (res.ok) {
        this.config = await res.json();
        return;
      }
    } catch (err) {
      console.error('Failed to load runtime-config.json', err);
      // Use hardcoded fallback for local dev
      this.config = { apiBaseUrl: 'https://localhost:7101/api/' };
    }
  }

  get apiBaseUrl(): string {
    const url = this.config?.apiBaseUrl ?? 'https://localhost:7101/api/';
    // Ensure trailing slash for consistency
    return url.endsWith('/') ? url : `${url}/`;
  }

  // Factory functions for DI
  static appInitializerFactory(config: RuntimeConfigService) {
    return () => config.load();
  }

  static apiUrlFactory(config: RuntimeConfigService): string {
    return config.apiBaseUrl;
  }
}
